import { render } from "./ToggleButton.vue?vue&type=template&id=1aa8e077&scoped=true"
import script from "./ToggleButton.vue?vue&type=script&lang=js"
export * from "./ToggleButton.vue?vue&type=script&lang=js"

import "./ToggleButton.vue?vue&type=style&index=0&id=1aa8e077&lang=scss&scoped=true"

import exportComponent from "/home/gui/adm/gpp-cmp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa8e077"]])

export default __exports__